(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-bundle-save"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-bundle-save')) {
    customElements.define('pl-bundle-save', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.item = this.querySelector('[data-bundle-item]');
        this.checkbox = this.querySelector('[data-item-check]');
        this.total = this.querySelector('[data-bundle-total]');
        this.compare = this.querySelector('[data-bundle-compare]');
        this.saving = this.querySelector('[data-bundle-saving]');
        this.savingRow = this.querySelector('[data-saving-row]');
        this.button = this.querySelector('[data-bundle-add]');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.status = this.querySelector('[data-bundle-status]');
        this.defaultButtonLabel = this.buttonLabel ? this.buttonLabel.textContent : '';

        this.checkbox?.addEventListener('change', () => this.updateTotals());
        this.button?.addEventListener('click', () => this.addSelected());
        this.updateTotals();
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'BRL';
        const locale = this.dataset.locale || 'pt-BR';
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
        } catch (error) {
          return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
        }
      }

      updateTotals() {
        if (!this.item) return;

        const selected = Boolean(this.checkbox?.checked) && this.item.dataset.available === 'true';
        const total = selected ? Number(this.item.dataset.price || 0) * Number(this.item.dataset.quantity || 1) : 0;
        const compare = selected ? Number(this.item.dataset.compare || 0) * Number(this.item.dataset.quantity || 1) : 0;
        const saving = Math.max(0, compare - total);

        this.item.classList.toggle('is-unselected', !selected);
        if (this.total) this.total.textContent = this.formatMoney(total);
        if (this.compare) {
          this.compare.textContent = this.formatMoney(compare);
          this.compare.hidden = compare <= total;
        }
        if (this.saving) this.saving.textContent = this.formatMoney(saving);
        if (this.savingRow) this.savingRow.hidden = saving <= 0;
        if (this.button) this.button.disabled = !selected;
        this.clearStatus();
      }

      selectedItems() {
        if (!this.item || !this.checkbox?.checked || this.item.dataset.available !== 'true') return [];
        return [{
          id: Number(this.item.dataset.variantId),
          quantity: Number(this.item.dataset.quantity || 1)
        }];
      }

      async addSelected() {
        const items = this.selectedItems();
        if (items.length === 0 || !this.button) {
          this.showStatus(this.dataset.emptyMessage, true);
          return;
        }

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.buttonLabel) this.buttonLabel.textContent = this.dataset.loadingLabel;
        this.clearStatus();

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorMessage);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.showStatus(error.message || this.dataset.errorMessage, true);
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          if (this.buttonLabel) this.buttonLabel.textContent = this.defaultButtonLabel;
        }
      }

      clearStatus() {
        if (!this.status) return;
        this.status.textContent = '';
        this.status.classList.remove('is-error');
      }

      showStatus(message, isError) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', Boolean(isError));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-image-carousel')) {
    customElements.define('pl-image-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.stage = this.querySelector('[data-stage]');
        this.previousButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.currentOutput = this.querySelector('[data-current]');
        this.dialog = this.querySelector('[data-dialog]');
        this.dialogImage = this.querySelector('[data-dialog-image]');
        this.dialogCaption = this.querySelector('[data-dialog-caption]');
        this.index = 0;
        this.startX = null;
        this.wasSwiping = false;
        this.autoplayTimer = null;

        if (!this.cards.length) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.stage?.addEventListener('keydown', (event) => this.onKeydown(event));
        this.stage?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.stage?.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.stage?.addEventListener('pointercancel', () => { this.startX = null; });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        this.addEventListener('shopify:block:select', (event) => this.selectThemeBlock(event));
        this.querySelector('[data-dialog-close]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.cards.forEach((card, cardIndex) => {
          card.querySelector('[data-image-button]')?.addEventListener('click', () => {
            if (this.wasSwiping) return;
            if (cardIndex !== this.index) {
              this.index = cardIndex;
              this.render();
              return;
            }
            this.openDialog(card);
          });
        });

        this.render();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      circularDifference(cardIndex) {
        let difference = cardIndex - this.index;
        const half = this.cards.length / 2;
        if (difference < -half) difference += this.cards.length;
        if (difference > half) difference -= this.cards.length;
        return difference;
      }

      render() {
        this.cards.forEach((card, cardIndex) => {
          card.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');
          const difference = this.circularDifference(cardIndex);

          if (difference === 0) card.classList.add('is-active');
          if (difference === -1) card.classList.add('is-prev');
          if (difference === 1) card.classList.add('is-next');
          if (difference === -2) card.classList.add('is-far-prev');
          if (difference === 2) card.classList.add('is-far-next');

          card.setAttribute('aria-hidden', difference === 0 ? 'false' : 'true');
          card.querySelector('[data-image-button]')?.setAttribute('tabindex', difference === 0 ? '0' : '-1');
        });

        if (this.currentOutput) this.currentOutput.textContent = String(this.index + 1);
      }

      move(direction) {
        this.index = (this.index + direction + this.cards.length) % this.cards.length;
        this.render();
        this.restartAutoplay();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.startX = event.clientX;
      }

      onPointerUp(event) {
        if (this.startX === null) return;
        const distance = this.startX - event.clientX;
        this.startX = null;
        if (Math.abs(distance) > 45) {
          this.wasSwiping = true;
          this.move(distance > 0 ? 1 : -1);
          window.setTimeout(() => { this.wasSwiping = false; }, 0);
        }
      }

      openDialog(card) {
        if (this.dataset.lightbox !== 'true' || !this.dialog || !this.dialogImage) return;
        const image = card.querySelector('.plic__image');
        const imageButton = card.querySelector('[data-image-button]');
        if (!image || !imageButton) return;

        this.dialogImage.src = imageButton.dataset.fullImage || image.currentSrc || image.src;
        this.dialogImage.alt = imageButton.dataset.fullAlt || image.alt || '';
        if (this.dialogCaption) {
          this.dialogCaption.textContent = imageButton.dataset.fullCaption || image.alt || '';
        }
        this.dialog.showModal();
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.cards.length < 2 || this.autoplayTimer) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const delay = Math.max(Number(this.dataset.delay || 5000), 2500);
        this.autoplayTimer = window.setInterval(() => {
          if (!document.hidden && !this.matches(':hover') && !this.matches(':focus-within')) this.move(1);
        }, delay);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      selectThemeBlock(event) {
        const card = event.target.closest('[data-card]');
        if (!card || !this.contains(card)) return;
        const selectedIndex = this.cards.indexOf(card);
        if (selectedIndex < 0) return;
        this.index = selectedIndex;
        this.render();
        this.stopAutoplay();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-main-product')) {
    customElements.define('pl-main-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.variantInput = this.querySelector('[data-variant-id]');
        this.price = this.querySelector('[data-current-price]');
        this.compare = this.querySelector('[data-compare-price]');
        this.discountBadge = this.querySelector('[data-discount-badge]');
        this.discountValue = this.querySelector('[data-discount-value]');
        this.button = this.querySelector('[data-add-button]');
        this.buttonLabel = this.querySelector('[data-add-label]');
        this.buttonPrice = this.querySelector('[data-button-price]');
        this.availableLabel = this.button ? this.button.dataset.availableLabel : '';
        this.soldOutLabel = this.button ? this.button.dataset.soldOut : '';

        this.querySelectorAll('[data-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId));
        });

        const kitRadios = Array.from(this.querySelectorAll('[data-kit-radio]'));
        kitRadios.forEach((radio) => {
          radio.addEventListener('change', () => {
            if (radio.checked) this.selectVariant(radio);
          });
        });

        const selectedKit = kitRadios.find((radio) => radio.checked && !radio.disabled) || kitRadios.find((radio) => !radio.disabled);
        if (selectedKit) {
          selectedKit.checked = true;
          this.selectVariant(selectedKit, false);
        }

        const select = this.querySelector('[data-variant-select]');
        if (select) {
          select.addEventListener('change', () => this.selectVariant(select.options[select.selectedIndex]));
          this.selectVariant(select.options[select.selectedIndex], false);
        }
      }

      selectVariant(source, updateUrl = true) {
        if (!source || !this.variantInput) return;

        this.variantInput.value = source.value;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

        this.querySelectorAll('.plmp__kit').forEach((kit) => kit.classList.remove('is-selected'));
        const selectedCard = source.closest('.plmp__kit');
        if (selectedCard) selectedCard.classList.add('is-selected');

        if (this.price && source.dataset.price) this.price.textContent = source.dataset.price;
        if (this.buttonPrice && source.dataset.price) this.buttonPrice.textContent = source.dataset.price;

        const hasCompare = Boolean(source.dataset.compare);
        if (this.compare) {
          this.compare.hidden = !hasCompare;
          this.compare.textContent = hasCompare ? source.dataset.compare : '';
        }

        const discount = Number(source.dataset.discount || 0);
        if (this.discountBadge) this.discountBadge.hidden = discount <= 0;
        if (this.discountValue) this.discountValue.textContent = `${discount}%`;

        const available = source.dataset.available === 'true';
        if (this.button) this.button.disabled = !available;
        if (this.buttonLabel) {
          this.buttonLabel.textContent = available ? this.availableLabel : (this.soldOutLabel || 'Esgotado');
        }

        if (source.dataset.mediaId) this.showMedia(source.dataset.mediaId);

        if (updateUrl && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', source.value);
          window.history.replaceState({}, '', url.toString());
        }
      }

      showMedia(mediaId) {
        if (!mediaId) return;
        this.querySelectorAll('[data-media-id].plmp__media').forEach((media) => {
          media.hidden = media.dataset.mediaId !== String(mediaId);
        });
        this.querySelectorAll('[data-thumb]').forEach((thumb) => {
          thumb.setAttribute('aria-current', thumb.dataset.mediaId === String(mediaId) ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
